// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__1vlDY","inner":"style_inner__evbBs","avatar":"style_avatar__2FaXo","info":"style_info__K82Kc"};